import React from 'react';

import { Typography, TypographyType } from '@lyearn/ui';
import { useContentDetails } from '@/components/ContentDetails/context';

function Label(props: Partial<TypographyType>) {
  const { content } = useContentDetails();

  if (!content?.label) {
    return null;
  }

  return (
    <Typography color="text-text-primary" variant="label-caps" {...props}>
      {content.label}
    </Typography>
  );
}

export default React.memo(Label);
